import { render } from "./UploadDocuments.vue?vue&type=template&id=1dd8f1e7"
import script from "./UploadDocuments.vue?vue&type=script&lang=js"
export * from "./UploadDocuments.vue?vue&type=script&lang=js"
script.render = render

export default script